export default {
  prepareSequenceImages: Array(36)
    .fill('')
    .map((v, i) =>
      require(`../../../Box_sequences/mirror/mirror${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/mirror/deskshelf.png'),
  designImageList: [
    {
      number: 1,
      side: 'RIGHT',
      image: require('../../../parts/deskshelf/1.png'),
    },
    {
      number: 2,
      side: 'LEFT',
      image: require('../../../parts/deskshelf/2.png'),
    },
    {
      number: 3,
      side: 'BACK',
      image: require('../../../parts/deskshelf/3.png'),
    },
    {
      number: 4,
      side: 'MIDDLE',
      image: require('../../../parts/deskshelf/4.png'),
    },
    {
      number: 5,
      side: 'BOTTOM',
      image: require('../../../parts/deskshelf/5.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/deskshelf/cutter.png'),
  assembleSequenceImages: Array(27)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/06_deskshelf_sequence/deskshelf${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/32shelf.png'),
  completeImagePc: require('../../../complete/32shelf.png'),
};
